import React from 'react'
import ContentCreateDemoPlayer from './createdemoplayermartin2'

export default function(props) {
    return <ContentCreateDemoPlayer {...props} apiType={'martin2'} />
}
